import React from 'react';
import PropTypes from 'prop-types';
import { Disclosure, Transition } from '@headlessui/react';
import clsx from 'clsx';

import { RiArrowDownSLine } from 'react-icons/ri';
import { Heading } from 'components';

function Accordion({ accordions, headingText, maxWidth }) {
  if (!accordions) return null;

  return (
    <div
      className={clsx('w-full', {
        'max-w-sm': maxWidth === 'sm',
        'max-w-md': maxWidth === 'md',
        'max-w-lg': maxWidth === 'lg',
        'max-w-xl': maxWidth === 'xl'
      })}
    >
      {headingText && (
        <Heading as="h3" noMargin>
          {headingText}
        </Heading>
      )}
      {accordions.map(accordion => (
        <Disclosure key={accordion.title} as="div" className="mt-4 first:mt-0">
          {({ open }) => (
            <>
              <Disclosure.Button className="flex w-full cursor-pointer items-center justify-between border-0 bg-deep-blue p-4 text-sm text-white shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-deep-blue focus-visible:ring-offset-2">
                {accordion.icon ? (
                  <div className="flex items-center space-x-4">
                    {typeof accordion.icon === 'object' ? (
                      accordion.icon
                    ) : (
                      <img
                        className="h-6 w-6 shrink-0 text-white"
                        src={accordion.icon}
                        alt=""
                      />
                    )}
                    <span>{accordion.title}</span>
                  </div>
                ) : (
                  <span>{accordion.title}</span>
                )}
                <RiArrowDownSLine
                  className={clsx('h-4 w-4 shrink-0 transition-transform', {
                    'rotate-180 transform': open
                  })}
                />
              </Disclosure.Button>
              <Transition
                enter="transition duration-150 ease-out"
                enterFrom="transform scale-95 opacity-0"
                enterTo="transform scale-100 opacity-100"
                leave="transition duration-150 ease-out"
                leaveFrom="transform scale-100 opacity-100"
                leaveTo="transform scale-95 opacity-0"
              >
                <Disclosure.Panel className="p-4 text-sm leading-relaxed text-dark-gray">
                  {accordion.content}
                </Disclosure.Panel>
              </Transition>
            </>
          )}
        </Disclosure>
      ))}
    </div>
  );
}

Accordion.propTypes = {
  accordions: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      content: PropTypes.node.isRequired
    })
  ).isRequired,
  headingText: PropTypes.string,
  maxWidth: PropTypes.oneOf(['sm', 'md', 'lg', 'xl'])
};

Accordion.defaultProps = {
  headingText: '',
  maxWidth: 'md'
};

export default Accordion;
